import { NavLink as RouterLink, useLocation } from 'react-router-dom';
import { Box, Link } from '@mui/material';

import { StackRow } from 'src/components';

//
//

type MenuItemProps = {
  title: string;
  path: string;
  hasSub?: boolean;
  open: boolean;
  name: string;
  hideOnDesktop?: boolean;
};

export const MenuItem: React.FC<MenuItemProps> = ({ title, path, open, hasSub, ...other }) => {
  const activeStyle = { color: 'primary.main' };
  const location = useLocation();

  if (other?.hideOnDesktop) return null;

  //

  return (
    <Link
      to={path}
      component={RouterLink}
      underline="none"
      color="inherit"
      variant="body2"
      sx={{
        display: 'flex',
        px: 0.5,
        py: 0.8,
        alignItems: 'center',
        gap: 0.5,
        fontWeight: 400,
        position: 'relative',
        transition: (theme) => theme.transitions.create('all'),
        '&:hover': activeStyle,
        ...(open && activeStyle),
      }}
      {...other}
    >
      <StackRow
        px={1.5}
        py={1.2}
        gap={1}
        sx={{
          borderRadius: '50px',
          backgroundColor: (theme) =>
            location.pathname.startsWith(`/${other?.name}`)
              ? theme.palette.primary.lighter
              : 'initial',
        }}
      >
        {title}

        {/* {hasSub && <IconChevronDown size={16} />} */}
      </StackRow>

      {/* Arrow */}
      {open && <TriangleWithShadows />}
    </Link>
  );
};

const TriangleWithShadows = () => {
  return (
    <Box
      sx={{
        width: 0,
        height: 0,
        borderLeft: '10px solid transparent',
        borderRight: '10px solid transparent',
        borderBottom: (theme) => `12px solid ${theme.palette.background.paper}`,
        position: 'absolute',
        bottom: -3,
        left: '37%',
        zIndex: (theme) => theme.zIndex.modal + 1,
        filter: (theme) =>
          `drop-shadow(1px 1px 6px rgba(0, 0, 0, 0.25)) drop-shadow(1px 1px 6px rgba(0, 0, 0, 0.25)) drop-shadow(1px 1px 6px ${theme.palette.background.paper}`,
      }}
    />
  );
};
